module.exports = __webpack_public_path__ + "img/youshi2.ccef6f0f.svg";